import { render, staticRenderFns } from "./historyTimeChange.vue?vue&type=template&id=ecc812a2&"
import script from "./historyTimeChange.vue?vue&type=script&lang=js&"
export * from "./historyTimeChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports